module.exports = __webpack_public_path__ + "img/ch21_07_花店满天星.de7956f7.jpg";